import React from "react";
let value = 0; //bugs arise if there are gradients with the same name
export default function ColorGradient(props) {
	value++;
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="3.4" height="55.867" viewBox="0 0 3.4 55.867">
			<defs>
				<linearGradient
					id={`linear-gradient${value}`}
					x1="0.961"
					y1="0.5"
					x2="0.031"
					y2="0.5"
					gradientUnits="objectBoundingBox"
				>
					<stop offset="0" stopColor="#6193bd" />
					<stop offset="0.23" stopColor="#be9fc4" />
					<stop offset="0.51" stopColor="#eeaa70" />
					<stop offset="0.749" stopColor="#ebd1a5" stopOpacity="0.89" />
					<stop offset="1" stopColor="#e48876" />
				</linearGradient>
			</defs>
			<path
				id="Path_4003"
				data-name="Path 4003"
				d="M0,0H55.867V3.4H0Z"
				transform="translate(0 55.867) rotate(-90)"
				fill={`url(#linear-gradient${value})`}
			/>
		</svg>
	);
}

export function ColorGradientLg() {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="10" height="62" viewBox="0 0 10 62">
			<defs>
				<clipPath id="clip-path">
					<rect
						id="Rectangle_1054"
						data-name="Rectangle 1054"
						width="283"
						height="62"
						rx="5"
						fill="#142541"
						stroke="#142541"
						strokeWidth="2"
					/>
				</clipPath>
				<linearGradient
					id="linear-gradient"
					x1="0.961"
					y1="0.5"
					x2="0.031"
					y2="0.5"
					gradientUnits="objectBoundingBox"
				>
					<stop offset="0" stopColor="#6193bd" />
					<stop offset="0.23" stopColor="#be9fc4" />
					<stop offset="0.51" stopColor="#eeaa70" />
					<stop offset="0.749" stopColor="#ebd1a5" stopOpacity="0.89" />
					<stop offset="1" stopColor="#e48876" />
				</linearGradient>
			</defs>
			<g id="Mask_Group_28" data-name="Mask Group 28" clipPath="url(#clip-path)">
				<path
					id="Path_4002"
					data-name="Path 4002"
					d="M0,0H62V10.8H0Z"
					transform="translate(0 62) rotate(-90)"
					fill="url(#linear-gradient)"
				/>
			</g>
		</svg>
	);
}
